import ReCAPTCHA from 'react-google-recaptcha'
import { forwardRef, useRef, useState } from 'react'
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import careerimg from "../assets/images/careers.png"
const url = process.env.REACT_APP_FORM_API_URL
const site_key = process.env.REACT_APP_RECAPTCHA_KEY;
const types = [
	"Office space",
	"Commercial space",
	"Commercial lot",
	"Industrial lot/Warehouse",
	"Other"
]
type TFormData = {
	email: string;
	lookingFor: string;
	fullname: string;
	phone: string;
	lotType: string;
	size: string;
	additionalMessage: string;
}
interface Prop {
	getRef?: ((ref: any) => void) | undefined
}
export default forwardRef((props, ref: any) => {
	const [step, setStep] = useState<number>(1)
	const [message, setMessage] = useState<string | null>(null)
	const captchaRef = useRef(null)
	const siteURL = useLocation();

	const [formData, setFormData] = useState<TFormData>({
		email: "",
		lookingFor: "",
		fullname: "",
		phone: "",
		lotType: "Office space",
		size: "",
		additionalMessage: ""
	})
	const handleSubmit = (e: any) => {
		e.preventDefault();
		if (formData.email === "" || formData.lookingFor === "") {
			return
		}
		setStep(2)
		const forms = Object.values(formData).map((d) => d)
		for (let form of forms) {
			if (form === "") {
				setMessage("Please you must complete the form.")
				return
			}
		}
		const fdata = new FormData()
		fdata.append('email', formData.email);
		fdata.append('fullname', formData.fullname);
		fdata.append('phone', formData.phone);
		fdata.append('url', siteURL.pathname);
		fdata.append('description', JSON.stringify({ ...formData }));
		if (!captchaRef.current?.getValue()) {
			alert("Please veriry captcha!")
			return
		}
		axios.post(`${url}`, fdata, {
			headers: {
				'Content-Type': 'multipart/form-data; ',
			}
		}).then((response) => {
			captchaRef.current?.reset()
			setMessage("Submitted!")
			setFormData({
				email: "",
				lookingFor: "",
				fullname: "",
				phone: "",
				lotType: "Office space",
				size: "",
				additionalMessage: ""
			})
			setStep(1)
		}).catch((error) => {
			setMessage("Faild to Send.")
		})
	}
	const radios = [
		{
			title: "I am looking for spaces",
			subtitle: "Inquire space from one of our leasing professionals",
			for: "spacesHelp"
		},
		{
			title: "I need a property consultation",
			subtitle: "Ask for assistance from our real estate advisors",
			for: "propertyHelp"
		}
	]
	const handleInput = (e: any) => {
		type t = { name: keyof TFormData, value: string }
		const { name, value }: t = e.target
		setFormData((prev) => ({ ...prev, [name]: value }))
	}
	return (
		<div className="card overflow-hidden shadow" ref={ref}>
			<div className="row g-0  p-4">
				<div className="col-lg-6 col-12 bg-white border border-1 p-4" style={{ zIndex: 1 }}>
					<div className="fs-4 p-4 text-center text-primary fw-bold">INQUIRE NOW</div>
					<div className='text-primary fs-5 text-center fw-bold mb-4'>Need help on your property needs? Contact our experts now!</div>
					<div className="fs-3 fw-bold text-danger">{message && message}</div>
					<form onSubmit={handleSubmit}>
						{
							step === 1 &&
							<div className="fs-4 d-flex flex-column w-100">
								<label htmlFor="emailInput">Enter your email address <span className="text-danger">*</span></label>
								<input required id="emailInput" type="email" className="fs-3 form-control" placeholder="Email address" name="email" onChange={handleInput}></input>
								<br />
								<p>What service do you need for help?</p>
								<div className="d-none text-danger" id="serviceFeedback">
									Please check at least one of the options.
								</div>

								{
									radios.map((rd, index) => {
										return <div key={index}>
											<div className="d-flex gap-2">
												<div className='mt-1'>
													<input required id={rd.for} className="form-check-input cursor-pointer" style={{ right: 5 }} type="radio" value={rd.title} name="lookingFor" onChange={handleInput} />
												</div>
												<label htmlFor={rd.for} className='cursor-pointer'>
													<div className="fw-bold">{rd.title}</div>
													<small className="fs-6 text-info">{rd.subtitle}</small>
												</label>
											</div>
											<hr />
										</div>
									})
								}
								<button type="submit" className="text-white bg-primary my-4 rounded-1 btn btn-primary p-4">Next</button>
							</div>
						}
						{
							step === 2 &&
							<div className="fs-4 d-flex flex-column w-100">
								<p>We need more information about you to address your questions:</p>
								<input required id="nameInput" type="text" className="fs-3 w-100 my-2 py-2 form-control" placeholder="Complete Name" name='fullname' onChange={handleInput}></input>
								<input required id="numberInput" type="tel" minLength={10} maxLength={11} className="fs-3 w-100 my-2 py-2 form-control" placeholder="Contact Number" name="phone" onChange={handleInput}></input>
								<select required id="typeInput" className="fs-3 w-100 my-2 py-2 form-control" placeholder="" name="lotType" onChange={handleInput}>
									{
										types.map((type: string) => (
											<option key={type} value={type}>{type}</option>
										))
									}
								</select>
								<input required id="sizeInput" type="text" className="fs-3 w-100 my-2 py-2 form-control" placeholder="Size Requirement" name="size" onChange={handleInput}></input>
								<input id="messageInput" type="textarea" className="fs-3 w-100 my-2 py-2 form-control" placeholder="Message" name="additionalMessage" onChange={handleInput}></input>
								<ReCAPTCHA
									ref={captchaRef}
									sitekey={site_key!}
								/>
								<button type="submit" onClick={handleSubmit} className="btn btn-primary my-2 rounded">Confirm</button>
							</div>
						}
					</form>
				</div>

				<div className="col-lg-6 d-none d-lg-inline">
					<img loading="lazy"
						className='w-100 h-100'
						src={careerimg}
						style={{
							objectFit: 'cover',
						}}
						alt="Image"
					/>
				</div>
			</div>
		</div>
	)
})